"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplantManufacturer_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ImplantBrand_1 = require("./ImplantBrand");
var ImplantManufacturer_Factory = /** @class */ (function () {
    function ImplantManufacturer_Factory() {
    }
    ImplantManufacturer_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ImplantBrands: model.ImplantBrands && model.ImplantBrands.map(function (i) { return ImplantBrand_1.ImplantBrand_Factory.CreateIncoming(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    ImplantManufacturer_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ImplantBrands: model.ImplantBrands && model.ImplantBrands.map(function (i) { return ImplantBrand_1.ImplantBrand_Factory.CreateOutgoing(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return ImplantManufacturer_Factory;
}());
exports.ImplantManufacturer_Factory = ImplantManufacturer_Factory;
